import { configureStore } from "@reduxjs/toolkit";
import ticketListSlice from "./ticketListSlice.tsx";
import notificationSlice from "./notificationSlice";
import configSlice from "./configSlice";
import chatSlice from "./chatSlice";
import userReducer from "./userSlice";
import callSlice from "@store/callSlice.tsx";
import userListSlice from "@store/userListSlice.tsx";
import addUserSlice from "@store/addUserSlice.tsx";
import securityGroupsSlice from "@store/securityGroupsSlice.tsx";
import networkSlice from "@store/networkSlice.tsx";

export const store = configureStore({
  reducer: {
    config: configSlice,
    tickets: ticketListSlice,
    notification: notificationSlice,
    chat: chatSlice,
    user: userReducer,
    call: callSlice,
    userList: userListSlice,
    addUser: addUserSlice,
    securityGroups: securityGroupsSlice,
    network: networkSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
